import { gql } from '@apollo/client';

export default gql`
  fragment ProjectReaderGroupFields on ProjectReaderGroup {
    id
    isApproved
    createdAt
    updatedAt
    __typename
  }
`;
